import Vue from "vue";
import CONFIG from "./../../config.js";

let actions = {
  addLog (context, params) {
    context.commit("addLog", params);
  },
  removeLog (context, params) {
    context.commit("removeLog", params);
  },
  generateRecaptcha (context, params) {
    return new Promise((resolve, reject) => {
      context.commit("addLog", { request: "generateRecaptcha" });
      grecaptcha.ready(() => {
        grecaptcha
          .execute(process.env.RECAPTCHA_KEY, params)
          .then(token => {
            context.commit("removeLog", { request: "generateRecaptcha" });
            resolve(token);
          })
      });
    });
  },
  storeMixpanelEvent (_context, params) {
    mixpanel.track(params.eventName, {
      [params.propertyName]: params.propertyValue
    });
  },
  registerMixpanelDefaults (_context, params) {
    mixpanel.register(params);
  }
};

export default actions;



// WEBPACK FOOTER //
// ./src/store/request/actions.js